import { useState, useEffect } from 'react';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';

export default function AboutPage() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar scrolled={scrolled} />
      
      <div className="pt-32 pb-24 bg-gradient-to-br from-black to-gray-800">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <h1 className="text-5xl font-bold text-white mb-6">關於朋睿</h1>
          <p className="text-xl text-white/90 max-w-3xl">
            成為企業最值得信賴的財務策略夥伴
          </p>
        </div>
      </div>

      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-20">
            <div>
              <img
                src="https://static.readdy.ai/image/43321df491d4a0e2e55deeaac186a2b1/b02a71d3924681ec6bc6974d619e83bc.jpeg"
                alt="專業團隊"
                className="w-full h-[500px] object-cover rounded-2xl shadow-xl"
              />
            </div>

            <div>
              <h2 className="text-4xl font-bold text-gray-900 mb-6">我們的使命</h2>
              <div className="text-gray-700 mb-6 leading-relaxed text-lg space-y-4">
                <p>「朋睿（Peng Rui）」寓意著「朋友般的信賴」與「睿智的財務規劃」。我們深知在企業經營的道路上，資金往往是決定成敗的關鍵一哩路。</p>
                <p>成立以來，我們致力於打破金融資訊的不對稱。許多優秀的創業者與中小企業主，專注於本業技術與市場，卻因不熟悉銀行語言或政策規範，而錯失了取得低成本資金的機會。</p>
                <p className="text-lg">朋睿團隊由具備銀行徵授信背景、財務會計師與政府專案顧問組成。我們不只是代辦，更是您的外部財務長。我們透過專業的財務健檢、營運計畫書優化與融資策略佈局，協助企業在不同成長階段，都能對接最合適的金融資源。</p>
              </div>
            </div>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-20">
            <div className="bg-gradient-to-br from-black/10 to-black/5 rounded-xl p-8 text-center">
              <div className="text-5xl font-bold text-black mb-3">專業</div>
              <div className="text-gray-600">金融顧問團隊</div>
            </div>
            <div className="bg-gradient-to-br from-black/10 to-black/5 rounded-xl p-8 text-center">
              <div className="text-5xl font-bold text-black mb-3">多元</div>
              <div className="text-gray-600">資金來源管道</div>
            </div>
            <div className="bg-gradient-to-br from-black/10 to-black/5 rounded-xl p-8 text-center">
              <div className="text-5xl font-bold text-black mb-3">精準</div>
              <div className="text-gray-600">需求分析評估</div>
            </div>
            <div className="bg-gradient-to-br from-black/10 to-black/5 rounded-xl p-8 text-center">
              <div className="text-5xl font-bold text-black mb-3">高效</div>
              <div className="text-gray-600">媒合執行流程</div>
            </div>
          </div>

          <div className="bg-gray-50 rounded-2xl p-12 mb-20">
            <h2 className="text-3xl font-bold text-gray-900 mb-8 text-center">核心價值</h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <div className="text-center">
                <div className="w-20 h-20 bg-black/10 rounded-full flex items-center justify-center mx-auto mb-6">
                  <i className="ri-lightbulb-line text-4xl text-black"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">專業顧問</h3>
                <p className="text-gray-600 leading-relaxed">
                  具備金融產業經驗的專業團隊，為您提供適切的資金規劃建議
                </p>
              </div>

              <div className="text-center">
                <div className="w-20 h-20 bg-black/10 rounded-full flex items-center justify-center mx-auto mb-6">
                  <i className="ri-links-line text-4xl text-black"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">多元管道</h3>
                <p className="text-gray-600 leading-relaxed">
                  整合銀行、創投、私募基金等多元資金來源，提供完整的媒合服務
                </p>
              </div>

              <div className="text-center">
                <div className="w-20 h-20 bg-black/10 rounded-full flex items-center justify-center mx-auto mb-6">
                  <i className="ri-customer-service-2-line text-4xl text-black"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">全程服務</h3>
                <p className="text-gray-600 leading-relaxed">
                  從需求評估到資金到位，提供完整的顧問服務，確保媒合順利
                </p>
              </div>
            </div>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-3xl font-bold text-gray-900 mb-6">為什麼選擇朋睿？</h2>
              <div className="space-y-6">
                <div className="flex items-start">
                  <div className="w-12 h-12 bg-black/10 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                    <i className="ri-shield-check-line text-2xl text-black"></i>
                  </div>
                  <div>
                    <h3 className="text-lg font-bold text-gray-900 mb-2">專業可靠</h3>
                    <p className="text-gray-600">經驗豐富的金融顧問團隊，提供專業的資金媒合服務</p>
                  </div>
                </div>

                <div className="flex items-start">
                  <div className="w-12 h-12 bg-black/10 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                    <i className="ri-team-line text-2xl text-black"></i>
                  </div>
                  <div>
                    <h3 className="text-lg font-bold text-gray-900 mb-2">廣泛人脈</h3>
                    <p className="text-gray-600">與多家銀行、創投、私募基金建立長期合作關係</p>
                  </div>
                </div>

                <div className="flex items-start">
                  <div className="w-12 h-12 bg-black/10 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                    <i className="ri-speed-line text-2xl text-black"></i>
                  </div>
                  <div>
                    <h3 className="text-lg font-bold text-gray-900 mb-2">高效執行</h3>
                    <p className="text-gray-600">完善的流程管理，確保媒合過程順利高效</p>
                  </div>
                </div>

                <div className="flex items-start">
                  <div className="w-12 h-12 bg-black/10 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                    <i className="ri-hand-heart-line text-2xl text-black"></i>
                  </div>
                  <div>
                    <h3 className="text-lg font-bold text-gray-900 mb-2">量身訂製</h3>
                    <p className="text-gray-600">依據不同需求提供客製化的資金解決方案</p>
                  </div>
                </div>
              </div>
            </div>

            <div>
              <img
                src="https://public.readdy.ai/ai/img_res/0db036a96a74afe3f6a18665dbf8f250.jpg"
                alt="為什麼選擇朋睿"
                className="w-full h-[500px] object-cover rounded-2xl shadow-xl"
              />
            </div>
          </div>
        </div>
      </section>

      <Footer />
      
      {/* LINE 客服按鈕 */}
      <a
        href="https://line.me/R/ti/p/@678gwbht"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-28 right-6 z-40 w-14 h-14 bg-[#06C755] rounded-full flex items-center justify-center text-white shadow-lg hover:scale-110 transition-transform duration-300 group"
        aria-label="LINE 即時諮詢"
      >
        <i className="ri-line-fill text-2xl"></i>
        <span className="absolute right-16 bg-gray-900 text-white px-3 py-1 rounded-lg text-sm whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          LINE 即時諮詢
        </span>
      </a>
    </div>
  );
}
